import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import Category2productFilterCriteria from './Category2productFilterCriteria'
import Category2productList from './Category2productList'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './Category2productAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setCategory2productDashboardCategory2productList } from '../../store/slice/ManufSlice';

export default function Category2productListView({setShowEdit,setCategory2productId}){
    const {filterCriteria} = useSelector((state)=>state.manufslice.category2productDashboard);   

    const [filteredCategory2productList, setFilteredCategory2productList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { category2productDashboard } = useSelector((state) => state.manufslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (category2productDashboard.category2productList.length>-1){
        setFilteredCategory2productList(category2productDashboard.category2productList);
        transformToCardFormat(category2productDashboard.category2productList, setCardList);
      }
    },[category2productDashboard.category2productList])

    useEffect(()=>{
          transformToCardFormat(filteredCategory2productList, setCardList);
      },[filteredCategory2productList])

    useEffect(()=>{
        if (filterCriteria.categoryid==='' && filterCriteria.productid==='' ){
            setFilteredCategory2productList(category2productDashboard.category2productList);
            transformToCardFormat(category2productDashboard.category2productList, setCardList);

        } else {
            setFilteredCategory2productList(
                category2productDashboard.category2productList
                    
                
            )
            

            //transformToCardFormat(category2productDashboard.filteredCategory2productList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <Category2productList
                    setShowEdit={setShowEdit}
                    setCategory2productId = {setCategory2productId}
                    tableList={filteredCategory2productList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}